import { render, staticRenderFns } from "./error-layout.vue?vue&type=template&id=5fc042e0&"
import script from "./error-layout.vue?vue&type=script&lang=js&"
export * from "./error-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports